import { ObjectiveLoadErrorMessage } from './ObjectivePageStates';
import PillarObjectivesHero, { PillarObjectivesHeroSkeleton } from './PillarObjectivesHero';

import type { PillarSummary } from '@/types/objectives';

interface PillarPageHeroProps {
    isLoading: boolean;
    /** The figures could not be counted: the error shows in their place, never a zero. */
    hasError: boolean;
    pillar?: PillarSummary;
}

/** The header of a pillar's page, in whichever state its figures are: read, being read, or failed. */
export default function PillarPageHero({ isLoading, hasError, pillar }: PillarPageHeroProps) {
    // An error read while the figures still load may yet clear; once they are read it stands.
    if (hasError && !isLoading) {
        return <ObjectiveLoadErrorMessage />;
    }

    if (isLoading || !pillar) {
        return <PillarObjectivesHeroSkeleton />;
    }

    return <PillarObjectivesHero pillar={pillar} />;
}
